export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Lt-d633274ad705f060a5d34b5b354f4df6.eot";